export enum RoomType {
    OT = 1,
    Recocery = 2,
}
